import {
  Flex,
  VStack,
  Text,
  Box,
  Image,
  Link
} from '@chakra-ui/react';

import { GoogleAuthProvider, EmailAuthProvider } from 'firebase/auth';

import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

import Const from '../Constants';

const uiConfig = {
  signInFlow: 'popup',
  signInOptions: [
    GoogleAuthProvider.PROVIDER_ID,
    EmailAuthProvider.PROVIDER_ID
  ],
  callbacks: {
    signInSuccessWithAuthResult: () => false
  }
};

function SignInView({ auth }) {
  return (
    <Flex
      minH={'100vh'}
      width={'100vw'}
      align={Const.sCenter}
      justify={Const.sCenter}
      padding={4}
      background={Const.Gray31}
      // glow background={`radial-gradient(ellipse at top, rgba(232, 83, 30, 0.10) 0%, ${Const.Gray31} 55%)`}
    >
      <VStack
        spacing={6}
        padding={10}
        borderRadius={'12px'}
        border={'1px solid'}
        borderColor={Const.Gray64}
        background={Const.Gray36}
        boxShadow={'0 20px 60px rgba(0, 0, 0, 0.45)'}
        maxW={'420px'}
        width={'100%'}
      >
        <VStack spacing={2}>
          <Image
            src={'/logo-white.svg'}
            alt={Const.sAppName}
            height={'44px'}
          />
          <Link
            href={'https://flowhero.ai/'}
            isExternal
            fontSize={Const.SM}
            color={Const.Gray165}
            _hover={{ color: Const.Orange400, textDecoration: 'underline' }}
          >
            flowhero.ai
          </Link>
        </VStack>

        <VStack spacing={2}>
          <Text fontSize={Const.MD} color={Const.White} textAlign={Const.sCenter}>
            The operating system for great engineering leadership.
          </Text>

          <Text fontSize={Const.SM} color={Const.Gray180} textAlign={Const.sCenter}>
            Click sign in to access the platform.
          </Text>

        </VStack>

        <Box width={'100%'} className={'signin-firebaseui'}>
          <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth} />
        </Box>
      </VStack>
    </Flex>
  );
}

export default SignInView;
